module.exports = __webpack_public_path__ + "img/transparent-nav-right-chevy.636e4b70.png";